var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("business")]),
          _vm._v(" Consulta de Items\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn-refresh",
              attrs: { slot: "activator" },
              nativeOn: {
                click: function($event) {
                  return function() {
                    _vm.filterShow = _vm.filterShow ? false : true
                  }.apply(null, arguments)
                }
              },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v("filter_list")])],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Búsqueda/filtros")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn-refresh",
              attrs: { slot: "activator" },
              nativeOn: {
                click: function($event) {
                  return _vm.listarServidores()
                }
              },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v("refresh")])],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("common.updateList")))])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c("transition", { attrs: { name: "slide-fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.filterShow,
                    expression: "filterShow"
                  }
                ],
                staticClass: "filter-container"
              },
              [
                _c("v-icon", { attrs: { small: "", color: "primary" } }, [
                  _vm._v("search")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Nro item", type: "number" },
                      on: { input: _vm.filterNroItem },
                      model: {
                        value: _vm.form.nro_item,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "nro_item", $$v)
                        },
                        expression: "form.nro_item"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Tipo movilidad" },
                      on: { input: _vm.filterMotivo },
                      model: {
                        value: _vm.form.motivo,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "motivo", $$v)
                        },
                        expression: "form.motivo"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "CI" },
                      on: { input: _vm.filterCi },
                      model: {
                        value: _vm.form.ci,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "ci", $$v)
                        },
                        expression: "form.ci"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Nombre" },
                      on: { input: _vm.filterNombreCompleto },
                      model: {
                        value: _vm.form.nombre_completo,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "nombre_completo", $$v)
                        },
                        expression: "form.nombre_completo"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Unidad" },
                      on: { input: _vm.filterNombreUnidad },
                      model: {
                        value: _vm.form.nombre_unidad,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "nombre_unidad", $$v)
                        },
                        expression: "form.nombre_unidad"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn-filter" },
                  [
                    _c(
                      "v-tooltip",
                      { attrs: { bottom: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { slot: "activator", icon: "", small: "" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.recargar()
                              }
                            },
                            slot: "activator"
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("refresh")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Recargar filtros")])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-tooltip",
                      { attrs: { bottom: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { slot: "activator", icon: "" },
                            nativeOn: {
                              click: function($event) {
                                return function() {
                                  _vm.filterShow = false
                                }.apply(null, arguments)
                              }
                            },
                            slot: "activator"
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("close")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Cerrar filtros")])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  items: _vm.lista_servidores,
                  headers: _vm.headers,
                  pagination: _vm.pagination,
                  "disable-initial-sort": true,
                  "item-key": "id",
                  search: _vm.filters,
                  "custom-filter": _vm.customFilter,
                  loading: _vm.loading,
                  "no-data-text": "No se tiene registros",
                  "no-results-text": "No se encontraron coincidencias",
                  "rows-per-page-items": [
                    10,
                    25,
                    50,
                    { text: "Todos", value: -1 }
                  ]
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.pagination = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "headers",
                    fn: function(props) {
                      return [
                        _c(
                          "tr",
                          _vm._l(props.headers, function(header) {
                            return _c(
                              "th",
                              {
                                key: header.text,
                                class: [
                                  "column sortable",
                                  _vm.pagination.descending ? "desc" : "asc",
                                  header.value === _vm.pagination.sortBy
                                    ? "active"
                                    : ""
                                ],
                                attrs: { id: "cabecera_tabla" },
                                on: {
                                  click: function($event) {
                                    return _vm.changeSort(header.value)
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { small: "", color: "white" } },
                                  [_vm._v("arrow_upward")]
                                ),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(header.text) +
                                    "\n            "
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ]
                    }
                  },
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.nro_item))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.motivo))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.ci))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(items.item.nombre_completo) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(items.item.nombre_unidad) +
                              "\n          "
                          )
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ee2f16b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee2f16b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/movilidad/ConsultaMovilidad.vue
// module id = null
// module chunks = 